import styled from 'styled-components'

const darkColor = (props) => props.theme.global.colors['dark-2']
const lineColor = "#939398"
const errorColor = "#f90000"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`

export const OrderInfo = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 4px;
  margin-bottom: 16px;

  @media screen and (max-width: 485px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const VerticalLine = styled.p`
  font-size: 16px;
  font-weight: 600;
  color: ${lineColor};
  margin: 0;

  @media screen and (max-width: 992px) {
    display: none;
  }
`

export const InfoText = styled.p`
  font-size: 16px;
  font-weight: 400;
  color: ${darkColor};
  margin: 0;

  span {
    font-size: 16px;
    font-weight: 600;
    color: ${darkColor};
    margin: 0;

    @media screen and (max-width: 992px) {
      font-size: 14px;
    }
  }

  @media screen and (max-width: 992px) {
    font-size: 14px;
  }
`

export const ErrorText = styled.p`
  font-size: 12px;
  font-weight: 400;
  color: ${errorColor};
  margin: 0;
`